export const buildKeyPerClientPartner = (client: string, partner: string): string =>
  `${client}-${partner}`;
